import React from 'react'
import {StickerColor, StickerIcon} from 'yougile-model'
import {IconStickerColor} from '@components/common/base/design-system'
import {Sticker, StickerProps} from '@components/common/base/sticker'
import {CustomIcons} from '@components/common/icon-tabler/custom-icons-16'

export interface SharedStickerProps {
  icon?: CustomIcons | StickerIcon | JSX.Element
  color?: StickerColor
  alwaysShowIconBackground?: boolean
  isDraggable?: boolean
  isDragging?: boolean
  showDraggableStyle?: boolean
  active?: boolean
  title?: string | JSX.Element
  onClick?: (event: React.MouseEvent) => void
  onMouseDown?: () => void
  rightIcon?: CustomIcons | JSX.Element
  onDragStart?: (event: DragEvent) => void
  onDragEnd?: (event: DragEvent) => void
  stickerRef?: React.ForwardedRef<HTMLDivElement>
  className?: string
  textClassName?: string
  leftIconClassName?: string
  required?: boolean
  hasError?: boolean
  hint?: React.ReactNode
  disabled?: boolean
}

export const StickerColors = {
  White: 'sticker-white',
  Gray: 'sticker-gray',
  Red: 'sticker-red',
  Pink: 'sticker-pink',
  Orange: 'sticker-orange',
  Green: 'sticker-green',
  Turquoise: 'sticker-turquoise',
  Blue: 'sticker-blue',
  Violet: 'sticker-violet',
  Transparent: 'sticker-transparent'
} as const

export const SharedSticker = React.forwardRef<HTMLDivElement, StickerProps>(
  (props, ref) => {
    const color = props.color || 'sticker-white'
    const iconColor: IconStickerColor = `icon-${color}`
    const iconBackgroundColor: IconStickerColor = `icon-${color}`
    const rightIconColor: IconStickerColor = `icon-${color}`

    return (
      <Sticker
        ref={ref}
        iconColor={iconColor}
        iconBackgroundColor={iconBackgroundColor}
        rightIconColor={rightIconColor}
        alwaysShowIconBackground
        {...props}
      />
    )
  }
)
